var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6001 14.35C19.6001 13.8858 19.7845 13.4407 20.1127 13.1125C20.4409 12.7844 20.886 12.6 21.3501 12.6C21.8142 12.6 22.2593 12.7844 22.5875 13.1125C22.9157 13.4407 23.1001 13.8858 23.1001 14.35C23.1001 14.8141 22.9157 15.2592 22.5875 15.5874C22.2593 15.9156 21.8142 16.1 21.3501 16.1C20.886 16.1 20.4409 15.9156 20.1127 15.5874C19.7845 15.2592 19.6001 14.8141 19.6001 14.35ZM12.6001 14.35C12.6001 13.8858 12.7845 13.4407 13.1127 13.1125C13.4408 12.7844 13.886 12.6 14.3501 12.6C14.8142 12.6 15.2593 12.7844 15.5875 13.1125C15.9157 13.4407 16.1001 13.8858 16.1001 14.35C16.1001 14.8141 15.9157 15.2592 15.5875 15.5874C15.2593 15.9156 14.8142 16.1 14.3501 16.1C13.886 16.1 13.4408 15.9156 13.1127 15.5874C12.7845 15.2592 12.6001 14.8141 12.6001 14.35ZM5.6001 14.35C5.6001 13.8858 5.78447 13.4407 6.11266 13.1125C6.44085 12.7844 6.88597 12.6 7.3501 12.6C7.81423 12.6 8.25935 12.7844 8.58753 13.1125C8.91572 13.4407 9.1001 13.8858 9.1001 14.35C9.1001 14.8141 8.91572 15.2592 8.58753 15.5874C8.25935 15.9156 7.81423 16.1 7.3501 16.1C6.88597 16.1 6.44085 15.9156 6.11266 15.5874C5.78447 15.2592 5.6001 14.8141 5.6001 14.35Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.d92d11254c772762fcc67784554c241c.svg";
export { ForwardRef as ReactComponent };